import React from "react";
import { Link } from "react-router-dom";
import SpaceParticles from "../../components/Particles/SpaceParticles";
import { FaArrowLeft } from "react-icons/fa";
import "./Admin.css";

const AdminHelp = () => {
  return (
    <div className="admin-page">
      <div className="admin-dashboard">
        <div className="admin-header">
          <h1 className="admin-title">Guia do Painel Administrativo</h1>
          <div className="admin-actions">
            <Link
              to="/admin/dashboard"
              className="admin-button admin-button-secondary"
            >
              <FaArrowLeft /> Voltar ao Dashboard
            </Link>
          </div>
        </div>

        <div className="admin-help-content">
          <section className="help-section">
            <h2>Como criar um novo post</h2>
            <ol>
              <li>
                No Dashboard, clique no botão <strong>"Novo Post"</strong>.
              </li>
              <li>
                Preencha o título, autor, conteúdo e outros campos conforme
                necessário.
              </li>
              <li>Adicione uma imagem de destaque (opcional).</li>
              <li>
                Adicione tags relevantes para ajudar na organização (opcional).
              </li>
              <li>
                Clique em <strong>"Salvar"</strong> para publicar seu post.
              </li>
            </ol>
          </section>

          <section className="help-section">
            <h2>Como editar um post existente</h2>
            <ol>
              <li>No Dashboard, localize o post que deseja editar na lista.</li>
              <li>
                Clique no ícone de edição <strong>(lápis)</strong> ao lado do
                post.
              </li>
              <li>Faça as alterações necessárias no conteúdo, título, etc.</li>
              <li>
                Clique em <strong>"Salvar"</strong> para atualizar o post.
              </li>
            </ol>
          </section>

          <section className="help-section">
            <h2>Como excluir um post</h2>
            <ol>
              <li>No Dashboard, localize o post que deseja excluir.</li>
              <li>
                Clique no ícone de lixeira <strong>(excluir)</strong>.
              </li>
              <li>Confirme a exclusão na tela de confirmação.</li>
              <li>
                <strong>Atenção:</strong> Esta ação não pode ser desfeita!
              </li>
            </ol>
          </section>

          <section className="help-section">
            <h2>Dicas para criar posts eficazes</h2>
            <ul>
              <li>
                <strong>Títulos:</strong> Crie títulos claros e atrativos.
              </li>
              <li>
                <strong>Imagens:</strong> Use imagens de alta qualidade,
                idealmente em 16:9.
              </li>
              <li>
                <strong>Conteúdo:</strong> Estruture seu texto com parágrafos
                curtos e subtítulos.
              </li>
              <li>
                <strong>Tags:</strong> Adicione tags relevantes para melhorar a
                organização.
              </li>
              <li>
                <strong>Resumo:</strong> Escreva um resumo conciso que atraia o
                leitor.
              </li>
            </ul>
          </section>
        </div>
      </div>
      <SpaceParticles />
    </div>
  );
};

export default AdminHelp;
